module.exports = __webpack_public_path__ + "img/how_to_build_habbit_forming.d491853d.jpg";